import { queryOptions } from "@tanstack/react-query";
import { getMe } from "../api/getMe";

const auth = {
    me: () => queryOptions({
        queryKey: ['me'],
        queryFn: getMe
    })
}

export { auth }